import { useQuery } from '@tanstack/react-query';
import { getSessions } from '../api/beachvision';

/**
 * React Query hook for the sessions list (dashboard).
 */
export function useSessions() {
  return useQuery({
    queryKey: ['beachvision', 'sessions'],
    queryFn: async () => {
      const res = await getSessions();
      return res.results || [];
    },
  });
}
